<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>瞄准配置</span>
          <clear-cache-apply />
          <sync-data />
        </div>

        <el-table size="mini" :data="formData" border style="width: 50%;min-height: 100px;" highlight-current-row>
          <el-table-column align="center" label="数值">
            <template slot-scope="{row}">
              <el-input v-model.number="row.num" placeholder="数值" />
            </template>
          </el-table-column>
          <el-table-column align="center" label="权重">
            <template slot-scope="{row}">
              <el-input v-model.number="row.v" placeholder="权重" />
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="{$index}">
              <el-button v-permisaction="['config:aimConfig:del']" size="mini" type="danger" @click="del($index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button v-permisaction="['config:aimConfig:add']" size="mini" type="primary" @click="add()">+</el-button>
        <el-button v-permisaction="['config:aimConfig:add']" size="mini" type="primary" @click="onSubmit()">保存</el-button>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'
export default {
  name: 'AimCfg',
  components: { SyncData, ClearCacheApply },
  data() {
    return {
      formData: [
        {
          'num': 0,
          'speed': 0,
          'v': 0
        }
      ]
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit() {
      for (const i in this.formData) {
        const tempDae = this.formData[i]
        if (tempDae.num <= 0) {
          this.msgError('数值必须大于0')
          return
        }
        this.formData[i].num = parseInt(tempDae.num)
        this.formData[i].v = parseInt(tempDae.v)
      }
      const data = JSON.stringify(this.formData)
      if (data.length < 1) {
        this.msgError('没有需要提交的数据')
        return
      }
      updateCommonCfg({ name: 'aimConfig', data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getCommonCfg({ name: 'aimConfig' }).then(res => {
        if (res.code === 200) {
          this.formData = res.data
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.formData.push({
        'num': 0,
        'v': 0
      })
    },
    del(index) {
      this.formData = this.formData.filter((item, key) => {
        return key !== index
      })
    }
  }
}
</script>

<style scoped>
</style>
